
import { z } from "zod";

export const TaskCompletionInvalidationScopeValues = ["TASK_ATTEMPTS", "HOMEOWNER_TIMELINE", "WORK_ORDERS", "BILLS", "INVOICES", "CREDIT_MEMOS", "VENDOR_CREDITS", "PROJECT_SCHEDULE", "MILESTONES", "BID", "QUOTING"] as const;
export const TaskCompletionInvalidationScopeSchema = z.enum(TaskCompletionInvalidationScopeValues);
export const TaskCompletionInvalidationScope = TaskCompletionInvalidationScopeSchema.enum;
export type TaskCompletionInvalidationScope = (typeof TaskCompletionInvalidationScopeValues)[number];
